import { SmsGroupTemplateType } from "@/models/club";
import clubRequest from "../axios";
import {
  CreateMerchantSmsTemplatePayload,
  UpdateMerchantSmsTemplatePayload,
} from "@/pages/dashboard/profile/template/type";

const createCustomTemplate = async (
  payload: CreateMerchantSmsTemplatePayload
) => (await clubRequest.smsTemplateCreate(payload)).data;

const updateCustomTemplate = async (
  payload: UpdateMerchantSmsTemplatePayload
) => (await clubRequest.smsTemplateUpdate(payload)).data;

const getAllSmsTemplate = async (smsGroupTemplateType: SmsGroupTemplateType) =>
  (
    await clubRequest.smsTemplateList({
      templateType: smsGroupTemplateType,
    })
  ).data;

const removeSmsTemplate = async (id: number) =>
  (
    await clubRequest.smsTemplateDelete({
      id,
    })
  ).data;

const smsTemplateService = {
  getAllSmsTemplate,
  createCustomTemplate,
  updateCustomTemplate,
  removeSmsTemplate,
};

export default smsTemplateService;
